export function isVerifiedUser(user) {
  if (!user || user === false) return false;
  const status = String(user.identity_verification_status || "").toLowerCase();
  return Boolean(user.identity_verified) || (Boolean(user.phone_verified) && status === "approved");
}

export default function VerifiedBadge({ className = "", title = "Verified player" }) {
  return (
    <svg
      viewBox="0 0 100 100"
      aria-label={title}
      title={title}
      role="img"
      className={`inline-block h-8 w-8 shrink-0 align-middle drop-shadow-[0_1px_1px_rgba(0,0,0,0.28)] ${className}`}
    >
      <g fill="#1d9bf0">
        <circle cx="50" cy="50" r="35" />
        <circle cx="50" cy="20" r="18" />
        <circle cx="71.2" cy="28.8" r="18" />
        <circle cx="80" cy="50" r="18" />
        <circle cx="71.2" cy="71.2" r="18" />
        <circle cx="50" cy="80" r="18" />
        <circle cx="28.8" cy="71.2" r="18" />
        <circle cx="20" cy="50" r="18" />
        <circle cx="28.8" cy="28.8" r="18" />
      </g>
      <circle cx="50" cy="50" r="32" fill="#2bb7f0" />
      <path
        d="M31 51.5 44 64.5 70 37"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="10"
      />
    </svg>
  );
}

export function VerifiedName({ className = "", name, user }) {
  return (
    <span className={`inline-flex min-w-0 items-center gap-2 align-middle ${className}`}>
      <span className="min-w-0 truncate">{name || "Player"}</span>
      {isVerifiedUser(user) && <VerifiedBadge />}
    </span>
  );
}
